<template>
    <div class="pagination-content">
        <div class="pagDiv"></div>
        <div>
            <div class="pagination">
                <span>共：{{data.total}}条 </span>
                <span class="pagination-left" @click="jump(prev)">&nbsp;</span>
                <span class="pageText">
                    <i>{{data.current_page}}</i>/{{data.last_page}}</span>
                <span class="pagination-right" @click="jump(next)">&nbsp;</span>
                <span>跳转</span>
                <input @keyup.enter="jump(page)" type="text" v-model="page">
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    props:{
        data: {
            type: Object,
            required: true,
            default:{},
        }
    },
    data() {
        return {
            page:""
        }
    },
    computed: {
        prev() {
            var num = this.data.current_page - 1;
            return num;
        },
        next() {
            var num = this.data.current_page + 1;
            return num;
        },
    },



    methods: {
        jump: function (page) {
            page = parseInt(page);
            if(page<=0){
                this.$message({
                    message: '已是首页',
                    type: 'warning'
                });
                return;
            }
            
            if(page>=this.data.last_page + 1){
                this.$message({
                    message: "暂无更多数据",
                    type: 'warning'
                });
                return;
            }
            
            this.$emit("getPage",page);
            
        }

    }
}
</script>


<style lang="less">
@import "~src/assets/less/var.less";

// 分页样式
.pagination-content {
    width: calc(~"100% - 200px"); // background: #e6e6e6;
    // background: #f2f3f7;
    background: #fff;
    border-top: 1px solid #ccc;
    box-sizing: border-box;
    height: @page-h;
    position: fixed;
    bottom: 0;
    left: 200px;
    &.inside{
        width: 100%;
        position: absolute;
        left:0;
    }
}

.pagination {
    height: 26px;
    line-height: 26px;
    color: #808080; // letter-spacing: 1.16px;
    vertical-align: top;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0;
}

.pagination>span:first-of-type {
    font-size: 14px;
}

@imgw: 24px; //左右按钮长宽
.pagination-left {
    display: inline-block;
    vertical-align: top; // width: 28px;
    background: url("~src/assets/image/left.png") no-repeat;
    margin: 0 10px;
    cursor: pointer;
    border: 1px solid #d8d8d8;
    border-radius: 3px;
    height: @imgw;
    width: @imgw; // box-sizing: border-box;
}

.pagination-right {
    display: inline-block;
    vertical-align: top;
    height: @imgw;
    width: @imgw;
    background: url("~src/assets/image/right.png") no-repeat;
    margin: 0 10px;
    cursor: pointer;
    border: 1px solid #d8d8d8;
    border-radius: 3px; // box-sizing: border-box;
}

.pagination-right+span {
    font-size: 14px;
}

.pagination>.pageText {
    background: #ffffff; // vertical-align: middle;
    border-radius: 4px;
    width: 78px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    display: inline-block;
    border: 1px solid #d8d8d8;
    font-size: 14px; // box-sizing: border-box;
}

.pagination>span>i {
    font-style: normal;
    color: #01b6ad;
}

.pagination>input {
    height: 26px;
    width: 40px;
    padding-left: 10px;
    color: #808080;
    margin-left: 10px; // box-shadow: 0px 0px 2px 0px rgba(178, 178, 178, 0.50);
    border: 1px solid #d8d8d8;
    border-radius: 3px;
    box-sizing: border-box;
    font-size: 14px;
}

.pagDiv {
    width: 100%;
    height: @page-h - 1px;
}
</style>



// WEBPACK FOOTER //
// pagination.vue?7239278e